<template>
  <Modal v-model="open" :title="title">
    <Form
      ref="formItem"
      :model="formItem"
      :label-width="80"
      :rules="ruleValidate"
    >
      <FormItem label="车辆名称" prop="car_name">
        <Input
          v-model="formItem.car_name"
          placeholder="请输入车辆名称"
          clearable
        />
      </FormItem>
      <FormItem label="计费价格" prop="car_price">
        <Input
          v-model="formItem.car_price"
          type="number"
          placeholder="请输入计费价格（未绑策略时作兜底小时价）"
          clearable
        />
      </FormItem>
      <FormItem
        v-if="formItem.type === 'passenger'"
        label="计费策略"
        prop="billing_strategy_id"
      >
        <Select
          v-model="formItem.billing_strategy_id"
          clearable
          filterable
          placeholder="不绑定则按区域/默认策略"
          style="width: 100%"
          :loading="billingStrategyLoading"
        >
          <Option
            v-for="s in billingStrategyOptions"
            :key="strategyOptionValue(s)"
            :value="strategyOptionValue(s)"
          >
            {{ strategyOptionLabel(s) }}
          </Option>
        </Select>
        <div class="field-hint">绑定后该车载人订单优先使用此策略</div>
      </FormItem>
      <FormItem label="车辆描述" prop="car_desc">
        <Input
          v-model="formItem.car_desc"
          placeholder="请输入车辆描述"
          clearable
        />
      </FormItem>
      <FormItem label="车辆标识" prop="car_ref">
        <Input
          v-model="formItem.car_ref"
          placeholder="请输入车辆标识"
          clearable
        />
      </FormItem>
      <FormItem label="车辆类型" prop="type">
        <Select v-model="formItem.type" style="width: 100%">
          <Option value="passenger">载人</Option>
          <Option value="cargo">载物</Option>
        </Select>
      </FormItem>
      <FormItem label="车辆状态" prop="status">
        <Select
          v-model="formItem.status"
          style="width: 100%"
          placeholder="请选择车辆状态"
        >
          <Option
            v-for="opt in statusOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </Option>
        </Select>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel('formItem')">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('formItem')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
import { CarAdd, CarEdit } from '@/api/car'
import { rideBillingList } from '@/api/rideBilling'

/** 管理端仅维护空闲 / 占用两种状态（与 /car/add、/car/edit 约定一致） */
const DEFAULT_STATUS = 'IDLE'

export default {
  name: 'AreaAddUpdate',
  data() {
    return {
      statusOptions: [
        { value: 'IDLE', label: '空闲' },
        { value: 'BUSY', label: '占用中' },
      ],
      billingStrategyOptions: [],
      billingStrategyLoading: false,
      formItem: {
        car_name: '',
        car_price: '',
        car_desc: '',
        car_ref: '',
        area_id: '',
        type: 'passenger',
        status: DEFAULT_STATUS,
        billing_strategy_id: '',
      },
      ruleValidate: {
        car_name: [
          { required: true, message: '请输入车辆名称', trigger: 'blur' },
        ],
        car_price: [
          { required: true, message: '请输入计费价格', trigger: 'blur' },
        ],
        car_desc: [
          { required: true, message: '请输入车辆描述', trigger: 'blur' },
        ],
        car_ref: [
          { required: true, message: '请输入车辆标识', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择车辆状态', trigger: 'change' },
        ],
      },
      open: false,
      title: '添加车辆',
      loading: false,
    }
  },
  methods: {
    /**
     * 表单仅 IDLE / BUSY；当前为空闲则空闲，否则（含历史 GOING 等）在表单中视为占用
     */
    normalizeStatusForForm(s) {
      const t = s != null ? String(s).trim() : ''
      if (t === 'IDLE') return 'IDLE'
      if (t === 'BUSY') return 'BUSY'
      if (!t) return DEFAULT_STATUS
      return 'BUSY'
    },
    strategyOptionValue(s) {
      if (!s || !s._id) return ''
      return typeof s._id === 'string' ? s._id : String(s._id)
    },
    strategyOptionLabel(s) {
      if (!s) return ''
      const summary = s.display_summary ? ` · ${s.display_summary}` : ''
      return `${s.name || '未命名'}${summary}`
    },
    loadBillingStrategies() {
      this.billingStrategyLoading = true
      rideBillingList({ status: 'on' })
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.billingStrategyOptions = (res.data.data || []).filter((s) => s.status === 'on')
          }
        })
        .finally(() => {
          this.billingStrategyLoading = false
        })
    },
    init(params) {
      console.log(params)
      this.loadBillingStrategies()
      const billingId = params.billing_strategy_id
      const billing_strategy_id = billingId ? String(billingId) : ''
      if (params._id) {
        this.title = '修改车辆'
        this.formItem = {
          ...params,
          car_name: params.carname || params.car_name,
          car_price: params.carprice || params.car_price,
          car_desc: params.cardesc || params.car_desc,
          car_ref: params.carref || params.car_ref,
          area_id: params.areaId || params.area_id,
          type: params.type || 'passenger',
          billing_strategy_id,
          status: this.normalizeStatusForForm(
            params.status ||
              params.vehicleStatus ||
              params.carStatus ||
              params.type_mes ||
              params.typemes
          ),
        }
      } else {
        this.title = '添加车辆'
        this.formItem = {
          car_name: '',
          car_price: '',
          car_desc: '',
          car_ref: '',
          area_id: params.areaId || params.area_id,
          type: 'passenger',
          status: DEFAULT_STATUS,
          billing_strategy_id: '',
        }
      }
      this.open = true
    },

    ok(name) {
      this.$refs[name].validate((valid) => {
        if (!valid) return
        const postData = JSON.parse(JSON.stringify(this.formItem))
        if (postData.type !== 'passenger') {
          postData.billing_strategy_id = null
        } else if (postData.billing_strategy_id) {
          postData.billing_strategy_id = String(postData.billing_strategy_id)
        } else {
          postData.billing_strategy_id = null
        }
        if (this.formItem._id) {
          CarEdit(postData)
            .then((res) => {
              if (res.data.code === 200) {
                this.$Message.success('车辆修改成功')
                this.cancel('formItem')
                this.$emit('reload')
              } else {
                this.$Message.error(res.data.msg)
              }
            })
            .catch((err) => {
              this.$Message.error(err)
            })
        } else {
          CarAdd(postData)
            .then((res) => {
              if (res.data.code === 200) {
                this.$Message.success('车辆添加成功')
                this.cancel('formItem')
                this.$emit('reload')
              } else {
                this.$Message.error(res.data.msg)
              }
            })
            .catch((err) => {
              this.$Message.error(err)
            })
        }
      })
    },

    cancel(name) {
      this.formItem = {
        car_name: '',
        car_price: '',
        car_desc: '',
        car_ref: '',
        area_id: '',
        type: 'passenger',
        status: DEFAULT_STATUS,
        billing_strategy_id: '',
      }
      this.$refs[name].resetFields()
      this.open = false
    }
  }
}
</script>

<style scoped>
.field-hint {
  color: #999;
  font-size: 12px;
  margin-top: 6px;
  line-height: 1.4;
}
</style>
